module.exports = __webpack_public_path__ + "static/media/background.9ee19a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/boston/background.jpg
// module id = 878
// module chunks = 27